import { Link } from "react-router-dom";
import Profile from "../assets/profile.jpg"; // Default profile image

// Function to create SEO-friendly slugs
const createSlug = (text) => {
  return text
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9\s-]/g, "")
    .replace(/\s+/g, "-");
};

export default function PropertyListCard({ property }) {
  const agentImage =
    property.agent?.profileimg && property.agent.profileimg.trim() !== ""
      ? property.agent.profileimg
      : Profile;

  const agentName =
    property.agent?.firstname && property.agent?.lastname
      ? `${property.agent.firstname} ${property.agent.lastname}`
      : "UrbanView Real Estate";

  const agentRole =
    property.agent?.designation && property.agent.designation.trim() !== ""
      ? property.agent.designation
      : "Property Manager";

  const imageUrl =
    Array.isArray(property.images) &&
    property.images.length > 0 &&
    property.images[0]?.path?.trim()
      ? property.images[0].path
      : "/1.jpg";

  const propertySlug = createSlug(property.ptitle);
  const agentSlug = createSlug(agentName);

  return (
    <div className="card border-0 rounded-0 shadow p-4">
      <div className="row">
        <div
          className="col-md-4 position-relative image-container overflow-hidden"
          style={{ height: "200px" }}
        >
          <Link
            to={`/property-details/${propertySlug}`}
            state={{ propertyId: property.pid }}
            className="text-decoration-none text-dark"
          >
            <img
              src={imageUrl}
              alt={property.ptitle}
              className="card-img-top img-fluid border"
              style={{ objectFit: "cover", height: "100%", width: "100%" }}
            />
          </Link>
        </div>

        <div className="col-md-8 px-3">
          <div className="d-flex justify-content-between">
            <span className="text-primary fw-bold">
              {property.pstatus === "Available"
                ? `${property.pstatus} for ${property.preason}`
                : property.pstatus}
            </span>

            <h6 className="text-primary fw-bold">
              {Number(property.priceguide) === 0 ? (
                "Contact the seller"
              ) : (
                <>
                  ${property.priceguide}
                  {property.pstatus === "Leased" && (
                    <span className="small">/Weekly</span>
                  )}
                </>
              )}
            </h6>
          </div>

          <Link
            to={`/property-details/${propertySlug}`}
            state={{ propertyId: property.pid }}
            className="text-decoration-none text-dark"
          >
            <h4 className="fw-bold">{property.ptitle}</h4>
          </Link>

          <p className="text-muted small">
            <i className="bi bi-geo-alt text-primary"></i>{" "}
            {property.address?.street_address}, {property.address?.suburb},{" "}
            {property.address?.state}
          </p>

          <div className="d-flex text-muted small">
            <span className="me-3">{property.beds} Bed</span>
            <span className="me-3">{property.baths} Bath</span>
            <span>
              <i className="bi bi-rulers"></i> {property.land_size} Square meter
            </span>
          </div>

          <div className="d-flex align-items-center mt-3">
            <Link
              to={`/team-details/${agentSlug}`}
              className="text-decoration-none text-dark"
              aria-label={`View profile of ${agentName}`}
            >
              <img
                src={agentImage}
                alt={agentName}
                className="rounded-circle me-2 border"
                style={{ width: "40px", height: "40px" }}
              />
            </Link>
            <div>
              <Link
                to={`/team-details/${agentSlug}`}
                className="text-decoration-none text-dark"
                aria-label={`View profile of ${agentName}`}
              >
                <h6 className="mb-0 fw-bold">{agentName}</h6>
              </Link>
              <small className="text-muted">{agentRole}</small>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}